import styles from "components/banner/BeltBanner.module.scss";
import Clipboard from "react-clipboard.js";
import {toast} from "react-toastify";


const BeltBanner = (props) => {
    const {children} = props;

    return (
        <div className={styles.container}>
            {children}
        </div>
    )
};


export const BokEventBeltBanner = (props) => {
    const {referral, handleShareClick, handleClipboardClick} = props;

    return (
        <BeltBanner>
            <span>
                {
                    referral ?
                        `내 초대코드: ${referral}`
                        :
                        '이벤트 공유하고 응모권 받기'
                }
            </span>
            <Clipboard
                option-text={() => {
                    return handleClipboardClick();
                }}
                onSuccess={() => {
                    toast.info('내 초대코드가 복사되었어요.', {'autoClose': 800});
                    handleShareClick();
                }}
                className={styles.share}
            >
                공유하고 응모권 받기
            </Clipboard>
        </BeltBanner>
    )
};


export const BokEventReferralBeltBanner = (props) => {
    const {referral, handleClipboardClick} = props;

    return (
        <BeltBanner>
            <span>초대 받은 코드: {referral}</span>
            <Clipboard
                option-text={() => {
                    return handleClipboardClick();
                }}
                onSuccess={() => {
                    toast.info('초대코드가 복사되었어요.', {'autoClose': 800});
                }}
                className={styles.share}
            >
                초대코드 복사하기
            </Clipboard>
        </BeltBanner>
    )
};
